import BossMode from '../../components/boss-mode/BossMode';
import { SubscriptionGuard } from '@/components/ui/subscription-guard';

export default function NewBossMode() {
  return (
    <SubscriptionGuard feature="boss_mode">
      <BossMode />
    </SubscriptionGuard>
  );
}
